import { SVGFC } from '@repo/toolkit/types'

const GenerateIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3252 6.34375C13.3252 6.73928 13.6465 7.05957 14.042 7.05957H15.3994L15.1963 6.82324L13.5771 4.93457L13.3252 4.64062V6.34375ZM12.4658 3.95508L12.3506 3.93262C12.2706 3.91715 12.1883 3.90919 12.1055 3.90918H5.44824C4.73632 3.90918 4.15918 4.48631 4.15918 5.19824V16.6562C4.15918 17.3682 4.73631 17.9453 5.44824 17.9453H13.7822C13.7891 17.9663 13.7958 17.9879 13.8008 18.0098L13.9814 18.8047H5.44824C4.26169 18.8047 3.2998 17.8428 3.2998 16.6562V5.19824C3.2998 4.01169 4.26169 3.0498 5.44824 3.0498H12.1055C12.7326 3.04985 13.3282 3.32368 13.7363 3.7998L16.2461 6.72754C16.5796 7.1168 16.7626 7.61245 16.7627 8.125V10.2852C16.5231 10.0875 16.2255 9.96181 15.9033 9.93262V8.125C15.9033 8.10153 15.9026 8.07807 15.9014 8.05469L15.8945 7.91895H14.042C13.1719 7.91895 12.4658 7.21388 12.4658 6.34375V3.95508Z"
        fill={color}
        stroke={color}
        strokeWidth="0.286458"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3197 11.3717C16.2604 11.1109 16.0285 10.9258 15.7611 10.9258C15.4936 10.9258 15.2617 11.1109 15.2024 11.3717L14.7793 13.2325C14.6327 13.8772 14.1292 14.3807 13.4844 14.5273L11.6236 14.9505C11.3628 15.0098 11.1777 15.2416 11.1777 15.5091C11.1777 15.7766 11.3628 16.0085 11.6236 16.0678L13.4844 16.4909C14.1292 16.6375 14.6327 17.141 14.7793 17.7858L15.2024 19.6466C15.2617 19.9074 15.4936 20.0924 15.7611 20.0924C16.0285 20.0924 16.2604 19.9074 16.3197 19.6466L16.7428 17.7858C16.8895 17.141 17.393 16.6375 18.0377 16.4909L19.8985 16.0678C20.1593 16.0085 20.3444 15.7766 20.3444 15.5091C20.3444 15.2416 20.1593 15.0098 19.8985 14.9505L18.0377 14.5273C17.393 14.3807 16.8895 13.8772 16.7428 13.2325L16.3197 11.3717ZM14.1723 15.5091C14.8956 15.2183 15.4703 14.6437 15.7611 13.9203C16.0519 14.6437 16.6265 15.2183 17.3499 15.5091C16.6265 15.7999 16.0519 16.3745 15.7611 17.0979C15.4703 16.3745 14.8956 15.7999 14.1723 15.5091Z"
        fill={color}
      />
    </svg>
  )
}

export default GenerateIcon
